module.exports = __webpack_public_path__ + "img/9.a97231a7.png";